export const themeColor = {
  bgOperators: 'rgb(237, 128, 46)',
  bgNumbers: '#dfdfdf',
  bgDisplay: '#858393',
  textColor: '#000',
};
export const numbersAndOperators = [
  {
    id: 'clear',
    symbol: 'AC',
    category: 'non-numeric',
  },
  {
    id: 'symbol',
    symbol: '+/-',
    category: 'non-numeric',
  },
  {
    id: 'percentage',
    symbol: '%',
    category: 'non-numeric',
  },
  {
    id: 'divide',
    symbol: '÷',
    category: 'operators',
  },
  {
    id: 'seven',
    symbol: '7',
    category: 'number',
  },
  {
    id: 'eight',
    symbol: '8',
    category: 'number',
  },
  {
    id: 'nine',
    symbol: '9',
    category: 'number',
  },
  {
    id: 'multiply',
    symbol: 'x',
    category: 'operators',
  },
  {
    id: 'four',
    symbol: '4',
    category: 'number',
  },
  {
    id: 'five',
    symbol: '5',
    category: 'number',
  },
  {
    id: 'six',
    symbol: '6',
    category: 'number',
  },
  {
    id: 'subtract',
    symbol: '-',
    category: 'operators',
  },

  {
    id: 'one',
    symbol: '1',
    category: 'number',
  },
  {
    id: 'two',
    symbol: '2',
    category: 'number',
  },
  {
    id: 'three',
    symbol: '3',
    category: 'number',
  },
  {
    id: 'add',
    symbol: '+',
    category: 'operators',
  },
  {
    id: 'zero',
    symbol: '0',
    category: 'number',
  },
  {
    id: 'decimal',
    symbol: '.',
    category: 'number',
  },
  {
    id: 'equals',
    symbol: '=',
    category: 'operators',
  },
];
